module.exports = __webpack_public_path__ + "static/media/cropped_smiling.6936e9db.webp";